<template>
  <div class="drawer fade-in" v-if="curUser">
    <div class="user-avatar">
      <div v-if="curUser" class="avatar-details">
        <div class="profile-icon">
          <font-awesome-icon class="icon" icon="fa-solid fa-user"/>
        </div>
        <div class="user-info">
          <h5>{{ curUser.Username }}</h5>
          <p>{{ curUser.Type }}</p>
          <p class="store-badge">{{ defaultStore }}</p>
        </div>
      </div>
    </div>

    <div class="routes">
      <template v-if="isOnline">
      <ul>

        <div class="box-container mt-2" v-if="isSmartInvoiceLive && shouldSmartInvoiceSignUp"
             @click="loginToOnlineBackOfficeSmartInvoice">
          <div class="box red-background-blink">
            <h6 class="route-btn"> Smart Invoicing Sign up </h6>
          </div>
        </div>

        <li :class="hasNoFloatAssigned">
          <router-link @click.native="back" :to="{ name : 'pos' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="basket-shopping"/>
            </div>
            Sales
          </router-link>
        </li>

        <li :class="!isOnline ? 'disabled' : ''">
          <router-link @click.native="back" :to="{ name : 'salesRecords' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-receipt"/>
            </div>
            Invoices
          </router-link>
        </li>




        <li>
          <router-link @click.native="back" :to="{ name : 'offline-invoices' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-cloud-arrow-up"/>
            </div>
            Offline Invoices
          </router-link>
        </li>

        <li v-if="isOnlineStoreRegistered">
          <router-link @click.native="back" :to="{ name : 'online-orders' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-bell"/>
            </div>
            Online Orders
          </router-link>
        </li>

        <li v-if="deviceSettings && deviceSettings.layby" :class="!isOnline ? 'disabled' : ''">
          <router-link @click.native="back" :to="{ name : 'lay-by-sales' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="circle-dollar-to-slot"/>
            </div>
            Sales On LayBy
          </router-link>
        </li>

<!--        <li v-if="deviceSettings && deviceSettings.layby" :class="!isOnline ? 'disabled' : ''">-->
<!--          <router-link @click.native="back" :to="{ name : 'hire-purchase-sales' }">-->
<!--            <div class="icon-box">-->
<!--              <font-awesome-icon class="icon" icon="circle-dollar-to-slot"/>-->
<!--            </div>-->
<!--            Hire Purchase Sales-->
<!--          </router-link>-->
<!--        </li>-->

        <li v-if="isLoyaltyActivated" :class="!isOnline ? 'disabled' : ''">
          <router-link @click.native="back" :to="{ name : 'loyalty-customers' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="heart-circle-check"/>
            </div>
            Loyalty Customers
          </router-link>
        </li>

        <li v-if="canViewBoffice" :class="!isOnline ? 'disabled' : ''">
          <a @click="loginToOnlineBackOffice">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="business-time"/>
            </div>
            Back Office (Admin)
          </a>
        </li>

        <li :class="!isOnline ? 'disabled' : ''">
          <a @click="stockTake">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="boxes"/>
            </div>
            Stock Take
          </a>
        </li>

        <li v-if="canViewStockTransfer" :class="!isOnline ? 'disabled' : ''">
          <a @click="stockTransfer">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="truck-moving"/>
            </div>
            Stock Transfer
          </a>
        </li>

        <li :class="!isOnline ? 'disabled' : ''">
          <a @click="cashup">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-coins"/>
            </div>
            End User Shift
          </a>
        </li>

        <li :class="!isOnline ? 'disabled' : ''">
          <a @click="cashupRecords">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="magnifying-glass-chart"/>
            </div>
            Cashup Records
          </a>
        </li>

        <li :class="!isOnline ? 'disabled' : ''">
          <a @click="ViewOpenTicket">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-receipt"/>
            </div>
            View Tickets
          </a>
        </li>

        <li :class="!isOnline ? 'disabled' : ''">
          <a @click="TicketRoute">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-gear"/>
            </div>
            Report an Issue
          </a>
        </li>

        <li>
          <router-link @click.native="back" :to="{ name : 'help' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-book"/>
            </div>
            User Manual
          </router-link>
        </li>

        <li>
          <a @click="settings">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-gear"/>
            </div>
            Device Settings
          </a>
        </li>

        <li>
          <a @click="closeApp">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-power-off"/>
            </div>
            Close App
          </a>
        </li>

        <li class="updates-entry" :class="{ 'has-update': updateAvailable }">
          <router-link @click.native="back" :to="{ name : 'updates' }">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-cloud-arrow-down"/>
              <span v-if="updateAvailable" class="badge-dot" aria-label="Update available"></span>
            </div>
            Download &amp; Update
          </router-link>
        </li>

        <li>
          <a @click="logout">
            <div class="icon-box">
              <font-awesome-icon class="icon" icon="fa-solid fa-arrow-right-from-bracket"/>
            </div>
            Log out
          </a>
        </li>
      </ul>
      </template>
      <template v-else>
        <ul>
          <li :class="hasNoFloatAssigned">
            <router-link @click.native="back" :to="{ name : 'pos' }">
              <div class="icon-box">
                <font-awesome-icon class="icon" icon="basket-shopping"/>
              </div>
              Sales
            </router-link>
          </li>

          <li>
            <router-link @click.native="back" :to="{ name : 'offline-invoices' }">
              <div class="icon-box">
                <font-awesome-icon class="icon" icon="fa-solid fa-cloud-arrow-up"/>
              </div>
              Offline Invoices
            </router-link>
          </li>

          <li>
            <router-link @click.native="back" :to="{ name : 'help' }">
              <div class="icon-box">
                <font-awesome-icon class="icon" icon="fa-solid fa-book"/>
              </div>
              User Manual
            </router-link>
          </li>

          <li>
            <a @click="settings">
              <div class="icon-box">
                <font-awesome-icon class="icon" icon="fa-solid fa-gear"/>
              </div>
              Device Settings
            </a>
          </li>

          <li>
            <a @click="closeApp">
              <div class="icon-box">
                <font-awesome-icon class="icon" icon="fa-solid fa-power-off"/>
              </div>
              Close App
            </a>
          </li>

          <li class="updates-entry" :class="{ 'has-update': updateAvailable }">
            <router-link @click.native="back" :to="{ name : 'updates' }">
              <div class="icon-box">
                <font-awesome-icon class="icon" icon="fa-solid fa-cloud-arrow-down"/>
                <span v-if="updateAvailable" class="badge-dot" aria-label="Update available"></span>
              </div>
              Download &amp; Update
            </router-link>
          </li>

          <li>
            <a @click="logout">
              <div class="icon-box">
                <font-awesome-icon class="icon" icon="fa-solid fa-arrow-right-from-bracket"/>
              </div>
              Log out
            </a>
          </li>
        </ul>
      </template>

      <div class="last-upd">
        Last Updated : {{ lastUpdated }}
      </div>
      <div class="app-version" v-if="appVersion">
        Version : {{ appVersion }}
      </div>
      <div class="app-version device-id" v-if="deviceId" :title="deviceId">
        Device ID : {{ deviceId }}
      </div>
      <div class="app-version device-id" v-if="deviceName" :title="deviceName">
        Device Name : {{ deviceName }}
      </div>
      <div class="app-version device-id" v-if="deviceSerial" :title="deviceSerial">
        Serial : {{ deviceSerial }}
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import {mapActions} from "vuex";
import {Storage} from "@/services/Storage";
import connectivityMonitor from '@/services/connectivityMonitor';
import { Device } from '@/services/Device';
import appPkg from "../../../../package.json";

export default {
  name: "NavigationDrawer",
  props: {
    close: {
      type: Function,
      required: true,
    }
  },
  data() {
    return {
      isOnline: true,
      deviceId: '',
      deviceName: '',
      deviceSerial: '',
    };
  },
  beforeMount() {
    this.checkSmartInvoicing();
    this.validateLogin();
    auth.isStoreSelected();

    // Initialize online status
    this.isOnline = connectivityMonitor.getStatus();

    // Subscribe to connectivity changes
    this.unsubscribeOnline = connectivityMonitor.subscribe('online', () => {
      this.isOnline = true;
    });
    this.unsubscribeOffline = connectivityMonitor.subscribe('offline', () => {
      this.isOnline = false;
    });

    // Check if store is registered for online orders
    this.checkOnlineStoreRegistration();
    this.loadDeviceInfo();
  },
  beforeDestroy() {
    // Clean up subscriptions
    if (this.unsubscribeOnline) this.unsubscribeOnline();
    if (this.unsubscribeOffline) this.unsubscribeOffline();
  },
  computed: {
    defaultStore() {
      const store = this.$store.getters.getDefaultStore;
      return store ? store.StoreName : '';
    },
    lastUpdated() {
      return this.$store.getters.getLasUpdated
    },
    appVersion() {
      return appPkg && appPkg.version ? appPkg.version : '';
    },
    curUser() {
      return this.$store.getters.getCurrentUser
    },
    deviceSettings() {
      return this.$store.getters.getDeviceSettings;
    },
    isLoyaltyActivated() {
      return this.$store.getters.getHasLoyalty;
    },
    isUpdateAvailable() {
      return this.$store.getters.getUpdateAvailability;
    },
    updateAvailable() {
      return !!this.$store.getters['updates/updatesAvailable'];
    },
    hasNoFloatAssigned() {
      return this.$route.name === "float" ? 'disabled' : '';
    },
    setMsg() {
      return this.curUser.Type === 'admin' ? '' : 'blocked'
    },
    shouldSmartInvoiceSignUp() {
      return !this.$store.getters.getSmartInvoicingStatus && !this.$store.getters.getDocSubmissionStatus;
    },
    isSmartInvoiceLive() {
      return this.$store.getters.getSmartInvoicingLive;
    },
    isOnlineStoreRegistered() {
      return this.$store.getters['orders/isOnlineStoreRegistered'];
    },
    /**
     * Checks if current user's security group allows viewing the Back Office menu item.
     * Uses the viewBoffice permission to control visibility of the Back Office (Admin) button.
     * @returns {boolean} true if user can see Back Office, false to hide it
     */
    canViewBoffice() {
      const securities = this.$store.getters.getSecurities || [];
      const userType = this.curUser?.Type;
      if (!userType) return false;
      const group = securities.find(sec => sec.GroupName?.toLowerCase() === userType.toLowerCase());
      // Default to true if permission not set (backwards compatible for existing groups)
      return group ? group.viewBoffice !== false : true;
    },
    /**
     * Checks if current user's security group allows viewing the Stock Transfer menu item.
     * Mirrors the canViewBoffice pattern. Uses the viewStockTransfer permission on the
     * user's security group to control visibility. Defaults to true (visible) when the
     * permission is not explicitly set, so existing security groups without the property
     * keep seeing the item — matching the canViewBoffice backwards-compat convention.
     *
     * Note: the click handler stockTransfer() ALSO re-checks the legacy
     * `franchiseSection` permission via validateSecurityPermission as a defence-in-depth
     * guard (in case a group is granted navigation here but the legacy permission is later
     * revoked on the backend).
     * @returns {boolean} true if user can see Stock Transfer, false to hide it
     */
    canViewStockTransfer() {
      const securities = this.$store.getters.getSecurities || [];
      const userType = this.curUser?.Type;
      if (!userType) return false;
      const group = securities.find(sec => sec.GroupName?.toLowerCase() === userType.toLowerCase());
      return group ? group.franchiseSection !== false : true;
    }
  },
  methods: {
    ...mapActions(['checkSmartInvoicing']),
    async loadDeviceInfo() {
      try {
        const info = await Device.getLoginDeviceInfo();
        this.deviceId = info.deviceId || '';
        this.deviceName = info.deviceName || '';
        this.deviceSerial = info.deviceSerial || '';
      } catch (e) {
        this.deviceId = '';
        this.deviceName = '';
        this.deviceSerial = '';
      }
    },
    async checkOnlineStoreRegistration() {
      try {
        await this.$store.dispatch('orders/checkRegistration');
      } catch (e) {
        console.warn('[NavigationDrawer] Failed to check online store registration', e);
      }
    },
    async validateLogin() {
      let isLoggedIn = await auth.isCashierLoggedIn();
      if (!isLoggedIn) {
        return this.$router.push({name: 'poslogin'})
      }
    },
    async logout() {
      let isAllowed = await this.$store.dispatch(`validateSecurityPermission`, `Loggoff`);
      if (!isAllowed) return responses.showWarning('User not allowed to logout');
      if(isAllowed){
        await this.$store.dispatch('posLogout')
        this.back();
      }
    },
    async closeApp() {
      let isAllowed = await this.$store.dispatch('validateSecurityPermission', 'ExitPos');
      if (!isAllowed) return responses.showWarning('User not allowed to close app');

      try {
        if (window.electronBridge && window.electronBridge.closeApp) {
          await window.electronBridge.closeApp();
        } else if (window.close) {
           window.close();
        } else {
          console.warn('Electron bridge not available');
          // Fallback for web environment or show message to user
          Swal.fire({
            title: 'Close App',
            text: 'Closing the application is only available in the desktop version.',
            icon: 'info',
            confirmButtonText: 'OK'
          });
        }
      } catch (error) {
        console.error('Error closing app:', error);
        window.close(); // Last ditch attempt
      }
    },
    async loginToOnlineBackOffice() {
      const defaultStoreObj = this.$store.getters.getDefaultStore;
      const curUserId = this.curUser && (this.curUser.id || this.curUser.Username) || '';
      console.log(`[deeplink][NavDrawer] click received curUser=${curUserId} defaultStore=${defaultStoreObj ? defaultStoreObj.StoreDB : ''}`);
      let isAllowed = await this.$store.dispatch(`validateSecurityPermission`, `Boffice`);
      console.log(`[deeplink][NavDrawer] permission=${!!isAllowed} dispatching openOnlineBackOffice`);
      if (isAllowed) {
        console.log('[NavigationDrawer] Opening Back Office...');
        await this.$store.dispatch(`openOnlineBackOffice`)
      } else {
        try {
          if (window?.responses?.showWarning) {
            window.responses.showWarning('User not allowed to access Back Office');
          } else if (window?.Swal) {
            await Swal.fire({ title: 'Permission required', text: 'You are not allowed to access Back Office.', icon: 'warning' });
          } else {
            console.warn('[NavigationDrawer] Back Office permission denied');
          }
        } catch (e) {
          console.warn('[NavigationDrawer] Failed to notify on Back Office permission denial:', e);
        }
      }
      return this.back();
    },
    async loginToOnlineBackOfficeSmartInvoice() {
      this.$store.dispatch(`openOnlineBackOffice`, {
        name: `smart-invoicing-setup`
      })
      return this.back();
    },
    back() {
      if (this.close) {
        this.close();
      } else {
        // Handle fallback
      }
    },
    async settings() {
      let isAllowed = await this.$store.dispatch(`validateSecurityPermission`, `Settings`);
      if (isAllowed) await this.$router.push({name: `settings`})
      return this.back();
    },
    SystemSupport() {
      this.$router.push({name: `ticket`})
    },
    updateApp() {
      this.$store.commit(`setUpdateAvailability`, false);
      return window.location.reload(true);
    },
    async ViewOpenTicket() {
      this.$router.push({name: 'ViewOpenTicket'})
      this.back()
    },
    async TicketRoute() {
      this.$router.push({name: 'TicketRequest'})
      this.back()
    },
    async cashupRecords() {
      let isAllowed = await this.$store.dispatch(`validateSecurityPermission`, `cashUpReports`);
      if (isAllowed) await this.$router.push({name: `cashup-records`})
      return this.back();
    },
    async stockTake() {
      let isAllowed = await this.$store.dispatch(`validateSecurityPermission`, `StockTake`);
      if (!isAllowed) return this.back();
      const route = this.$store.getters.getStockTakeRoute;
      await this.$router.push(route);
      return this.back();
    },
    /**
     * Route the cashier to the Stock Transfer hub
     * (`views/boffice/stock-transfer/SelectTransferTypeView.vue`).
     * Mirrors the existing `stockTake()` pattern: gate on the
     * `StockTransfer` security permission (set on each user-group's
     * `securities` document by the backend team) and close the drawer
     * regardless of whether navigation succeeds.
     *
     * The hub view dispatches `stockTransfer/getAllStores` on mount so
     * the Send -> SelectReceivingStore list (and its pinned Main Store
     * card via `stockTransfer/getMainStore`) have data on first paint.
     *
     * @returns {Promise<void>}
     */
    async stockTransfer() {
      let isAllowed = await this.$store.dispatch(`validateSecurityPermission`, `franchiseSection`);
      if (!isAllowed) {
        if (window?.responses?.showWarning) {
          window.responses.showWarning('User not allowed to access Stock Transfer');
        }
        return this.back();
      }
      await this.$router.push({ name: 'stock-transfer' });
      return this.back();
    },
    async cashup() {

      await this.$router.push({name: `cashup`})
      return this.back();
    },
  }
}
</script>

<style lang="scss" scoped>
.disabled {
  pointer-events: none;
  display: none;
}

.drawer {
  width: 100%;
  max-width: 100%;
  background: var(--card-bg);
  height: 100vh;
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  box-shadow: var(--card-shadow);
  font-family: var(--font-family);
  transition: var(--transition-speed);
  position: relative;
  overflow: hidden;

  // Add subtle pattern to background
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image:
        radial-gradient(circle at 10% 20%, rgba(51, 156, 255, 0.03) 0%, transparent 20%),
        radial-gradient(circle at 90% 80%, rgba(165, 41, 255, 0.03) 0%, transparent 20%);
    opacity: 0.6;
    z-index: 0;
    pointer-events: none;
  }

  .user-avatar {
    display: flex;
    width: 100%;
    max-width: 100%;
    background: linear-gradient(135deg, var(--accent-electric-blue) 0%, var(--accent-neon-purple) 100%);
    color: white;
    min-height: 120px;
    flex-shrink: 0;
    padding: 20px 16px;
    position: relative;
    border-bottom: var(--card-border);
    overflow: hidden;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);

    // Add subtle pattern to background
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-image:
          radial-gradient(circle at 20% 30%, rgba(255, 255, 255, 0.2) 0%, transparent 25%),
          radial-gradient(circle at 80% 70%, rgba(255, 255, 255, 0.15) 0%, transparent 25%);
      opacity: 0.6;
      z-index: 0;
    }

    // Shine effect
    &::after {
      content: '';
      position: absolute;
      top: -50%;
      left: -50%;
      width: 200%;
      height: 200%;
      background: linear-gradient(
              to right,
              rgba(255, 255, 255, 0) 0%,
              rgba(255, 255, 255, 0.15) 50%,
              rgba(255, 255, 255, 0) 100%
      );
      transform: rotate(30deg);
      animation: shine 6s infinite;
    }

    .avatar-details {
      width: 100%;
      max-width: 100%;
      position: relative;
      z-index: 1;
      display: flex;
      align-items: center;
      gap: 16px;
      animation: fadeIn 0.5s ease;
      overflow: hidden;

      .profile-icon {
        width: 56px;
        height: 56px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 2px solid rgba(255, 255, 255, 0.3);
        backdrop-filter: blur(4px);
        box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
        flex-shrink: 0;

        .icon {
          font-size: 24px;
          color: white;
        }
      }

      .user-info {
        flex: 1;
        min-width: 0;
        overflow: hidden;

        h5 {
          margin: 0 0 6px 0;
          font-size: 1.2rem;
          font-weight: 700;
          letter-spacing: 0.5px;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          animation: fadeIn 0.5s ease 0.1s backwards;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        p {
          margin: 3px 0;
          font-size: 0.85rem;
          color: rgba(255, 255, 255, 0.9);
          font-weight: 400;
          animation: fadeIn 0.5s ease 0.2s backwards;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;

          &.store-badge {
            color: #ffffff;
            font-weight: 500;
            margin-top: 8px;
            padding: 6px 12px;
            background: rgba(255, 255, 255, 0.15);
            border-radius: 10px;
            display: inline-block;
            backdrop-filter: blur(4px);
            border: 1px solid rgba(255, 255, 255, 0.2);
            box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
            animation: fadeIn 0.5s ease 0.3s backwards;
            max-width: 100%;
            position: relative;
            overflow: hidden;

            // Add subtle shine effect
            &::after {
              content: '';
              position: absolute;
              top: -50%;
              left: -50%;
              width: 200%;
              height: 200%;
              background: linear-gradient(
                to right,
                rgba(255, 255, 255, 0) 0%,
                rgba(255, 255, 255, 0.1) 50%,
                rgba(255, 255, 255, 0) 100%
              );
              transform: rotate(30deg);
              animation: shine 6s infinite;
              z-index: 0;
            }

            &:hover {
              background: rgba(255, 255, 255, 0.2);
              transform: translateY(-1px);
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            }
          }
        }
      }
    }
  }

  .routes {
    position: relative;
    z-index: 1;
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 8px 0 0 0;

    // Custom scrollbar
    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(var(--accent-electric-blue-rgb), 0.3);
      border-radius: 2px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: rgba(var(--accent-electric-blue-rgb), 0.5);
    }

    ul {
      list-style: none;
      margin: 0;
      padding: 0;
      cursor: pointer;

      li {
        padding: 0;
        margin: 6px 0;
        transition: transform 0.2s ease;

        &:hover {
          transform: translateX(2px);
        }

        &.disabled {
          opacity: 0.4;
          pointer-events: none;
          cursor: not-allowed;

          &:hover {
            transform: none;
          }

          a {
            color: var(--text-secondary);
            cursor: not-allowed;

            .icon-box {
              background: rgba(128, 128, 128, 0.1);

              .icon {
                color: var(--text-secondary);
              }
            }
          }
        }

        a {
          height: 50px;
          display: flex;
          flex-direction: row;
          align-items: center;
          font-weight: 500;
          padding: 0 16px;
          text-decoration: none;
          color: var(--text-primary);
          border-radius: 10px;
          margin: 0 10px;
          transition: var(--transition-speed);
          position: relative;
          overflow: hidden;
          white-space: nowrap;

          // Add subtle hover effect
          &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: linear-gradient(to right,
                rgba(var(--accent-electric-blue-rgb), 0.05),
                rgba(var(--accent-neon-purple-rgb), 0.05));
            opacity: 0;
            transition: var(--transition-speed);
            z-index: -1;
          }

          .icon-box {
            width: 36px;
            height: 36px;
            margin-right: 12px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 8px;
            background: rgba(var(--accent-electric-blue-rgb), 0.1);
            transition: var(--transition-speed);
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
            flex-shrink: 0;

            .icon {
              font-size: 16px;
              color: var(--accent-electric-blue);
              transition: var(--transition-speed);
            }
          }

          .update-text {
            display: flex;
            flex-direction: column;
            text-align: left;
            overflow: hidden;

            .text-sm {
              font-size: 0.75rem;
              opacity: 0.8;
              margin-top: 2px;
            }
          }

          &:hover, &.router-link-exact-active {
            background: var(--secondary-button-bg);
            color: var(--accent-electric-blue);
            font-weight: 600;
            box-shadow: var(--card-shadow);

            &::after {
              opacity: 1;
            }

            .icon-box {
              background: var(--accent-electric-blue);
              transform: scale(1.05);
              box-shadow: 0 3px 8px rgba(var(--accent-electric-blue-rgb), 0.2);

              .icon {
                color: white;
              }
            }
          }

          // Active state
          &.router-link-exact-active {
            background: linear-gradient(to right,
                rgba(var(--accent-electric-blue-rgb), 0.1),
                rgba(var(--accent-neon-purple-rgb), 0.05));
            border-left: 3px solid var(--accent-electric-blue);
            padding-left: 13px; // Compensate for the border
          }
        }
      }
    }

    .last-upd {
      font-size: 0.75rem;
      color: var(--text-secondary);
      text-align: center;
      padding: 12px 16px;
      margin-top: 8px;
      border-top: var(--card-border);
      opacity: 0.8;
      transition: var(--transition-speed);
      flex-shrink: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &:hover {
        opacity: 1;
      }
    }

    .app-version {
      font-size: 0.75rem;
      color: var(--text-secondary);
      text-align: center;
      padding: 6px 16px 12px 16px;
      opacity: 0.75;
      transition: var(--transition-speed);
      flex-shrink: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      &:hover {
        opacity: 1;
      }

      &.device-id {
        white-space: normal;
        word-break: break-all;
        user-select: all;
        overflow: visible;
        text-overflow: unset;
        padding-top: 0;
      }
    }
  }
}

.box-container {
  display: flex;
  justify-content: center;
  margin: 12px 10px;
  overflow: hidden;
}

.red-background-blink {
  background: linear-gradient(45deg, var(--danger), #ff6b6b);
  animation: blink 1.5s infinite;
  padding: 10px 20px;
  border-radius: 10px;
  box-shadow: 0 3px 8px rgba(255, 75, 75, 0.2);
  transition: var(--transition-speed);

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 75, 75, 0.3);
  }
}

// In-app update flow badge (see docs/exec-plans/active/2026-06-23-app-update-flow.md).
// The red dot appears next to the cloud-arrow-down icon when an update
// is available; the cashier navigates to /updates from here.
.updates-entry {
  .icon-box {
    position: relative;
  }
  .badge-dot {
    position: absolute;
    top: -2px;
    right: -2px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #dc3545;
    box-shadow: 0 0 0 2px var(--card-bg);
    animation: blink 1.2s infinite;
  }
}
.updates-entry.has-update {
  a {
    color: var(--text-primary);
    font-weight: 600;
  }
  .icon-box .icon {
    color: var(--accent-electric-blue);
  }
}

.box {
  display: inline-block;
}

.route-btn {
  color: white;
  background: transparent;
  border: none;
  font-size: 0.9rem;
  font-weight: 600;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.text-white {
  color: white;
}

// Dark mode adjustments
[data-theme='dark'] .drawer {
  background: var(--card-bg);

  .routes ul li a {
    color: var(--text-primary);

    .icon-box {
      background: rgba(var(--accent-electric-blue-rgb), 0.15);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    &:hover, &.router-link-exact-active {
      background: rgba(var(--accent-electric-blue-rgb), 0.1);
    }
  }

  .routes .last-upd {
    border-top: var(--card-border);
  }
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}

@keyframes shine {
  20% {
    transform: translateX(-100%) rotate(30deg);
  }
  30%, 60% {
    transform: translateX(100%) rotate(30deg);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

// Mobile responsiveness
@media (max-width: 480px) {
  .drawer {
    .user-avatar {
      min-height: 100px;
      padding: 16px 12px;

      .avatar-details {
        gap: 12px;

        .profile-icon {
          width: 48px;
          height: 48px;

          .icon {
            font-size: 20px;
          }
        }

        .user-info {
          h5 {
            font-size: 1.1rem;
          }

          p {
            font-size: 0.8rem;

            &:nth-child(3) {
              padding: 4px 8px;
              font-size: 0.75rem;
            }
          }
        }
      }
    }

    .routes {
      ul li a {
        height: 44px;
        padding: 0 12px;
        margin: 0 8px;
        font-size: 0.9rem;

        .icon-box {
          width: 32px;
          height: 32px;
          margin-right: 10px;

          .icon {
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>

